const websiteName = process.env.REACT_APP_WEBSITE_NAME;
const googleOptimizeKey = process.env.REACT_APP_GOOGLE_OPTIMIZE_ID;

export const GOOGLE_OPTIMIZE_SCRIPT = `var go = document.createElement("script"),
go_s = document.getElementsByTagName("script")[0];
go.type = "text/javascript";
go.src = "https://www.googleoptimize.com/optimize.js?id=${googleOptimizeKey}";
go_s.parentNode.insertBefore(go, go_s);`;

export const ANTI_FLICKER_SCRIPT = `(function(a,s,y,n,c,h,i,d,e){var k=(typeof s.className==='string'?s.className:(s.className&&s.className.baseVal)||'');s.className=(k+' '+y).trim();h.start=1*new Date;h.end=i=function(){var q=(typeof s.className==='string'?s.className:(s.className&&s.className.baseVal)||'');s.className=q.replace(RegExp(' ?'+y),'')};(a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;})(window,document.documentElement,'async-hide','dataLayer',4000,{'${websiteName}':true});`;
